import { snakeCaseToTitleCase } from '@agilelab/plugin-wb-platform-common';

export const getCompactNotificationKind = (notificationKind: string) => {
  return notificationKind.replace('notification:', '');
};

export const getCompactRecipientType = (recipientType: string) => {
  return recipientType.replace('recipient-type:', '');
};

export const getNotificationKindDisplayName = (notificationKind: string) => {
  if (notificationKind.startsWith('notification:'))
    return snakeCaseToTitleCase(getCompactNotificationKind(notificationKind));
  return snakeCaseToTitleCase(notificationKind);
};

export const getRecipientTypeDisplayName = (recipientType: string) => {
  if (recipientType.startsWith('recipient-type:'))
    return snakeCaseToTitleCase(getCompactRecipientType(recipientType));
  return snakeCaseToTitleCase(recipientType);
};
